import { httpRequest } from "../../../http";

export class CommandUnlinkNetworkResource {
  async run(childId: number, parentId: number) {
    try {
      await httpRequest<any>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_accounts/network_resources/${childId}/unlink/`,
        {
          method: "POST",
          body: JSON.stringify({ parent_id: parentId }),
        },
      );
    } catch (error) {
      console.error("Error creating network resource:", error);
      throw error;
    }
  }
}
